@for (item of links; track $index) {
  <a [routerLink]="item.link" class="nav__item">
    <span class="nav__item-text">{{ item.label | translate }}</span>
  </a>
}
